import { Ldap, LdapContainer } from './../core/models/ldap';
import { LdapService } from './../core/services/ldap.service';
import { Component, OnInit, ViewChild, ElementRef, AfterViewChecked, ChangeDetectorRef } from '@angular/core';
import * as _ from 'lodash';
import {BzgToastService, BzgModalService, BzgModalRef} from 'bz-genome-angular';
import {TranslateService} from '@ngx-translate/core';
import { LdapBasicConfigurationComponent } from './ldap-basic-configuration/ldap-basic-configuration.component';
import { Subscription } from 'rxjs';
import { Store } from '@ngrx/store';
import { ILdapTestResults } from '../core/typings/ILdapTestResults';
import { LdapTestResultsComponent } from './ldap-test-results/ldap-test-results.component';
import { IAppState } from 'app/IAppState';

@Component({
    selector: 'security-ldap',
    templateUrl: 'security-ldap.component.html',
    styleUrls: ['security-ldap.component.scss']
})
export class SecurityLdapComponent implements OnInit, AfterViewChecked {
    public readonly ERRORS_ATTRIBUTE = [
      'ContactEmailAttributeMissing',
      'FullNameAttributeMissing'
    ]

    public _ldapEnvironment: Ldap;
    public isLoadingLdap: boolean;
    public isTestingLdap: boolean;
    public testResults: ILdapTestResults;
    public isTestingResultOk: boolean;
    public userProperties: any[];
    public tabs: any;
    public selectedTab: number = 0;

    private _ldapContainer: LdapContainer;
    private ldapResult: any;
    private ldapEnvironments: Ldap[];
    private _tabsSubscription: Subscription;

    @ViewChild('ldapBasicConfiguration', { static: false}) ldapBasicConfiguration: LdapBasicConfigurationComponent;

    constructor(private ldapService: LdapService,
                private _toastService: BzgToastService,
                private _translateService: TranslateService,
                private _store: Store<IAppState>,
                private _modalService: BzgModalService,
                private cdRef : ChangeDetectorRef) { }

    ngOnInit() {

        this.isLoadingLdap = true;

        this._tabsSubscription = this._store
            .select((s) => s.menuOptions)
            .subscribe((menuOptions: any) => {
                this.tabs = menuOptions['Ldap'];
        });

        const currentEnvironment = sessionStorage.getItem('environmentType');

        this.ldapService.getLdapConfiguration().subscribe((response: any) => {
            this.isLoadingLdap = false;
            this.ldapResult = response;

            this._ldapContainer = response[0].content;
            this.ldapEnvironments = JSON.parse(this._ldapContainer.environments);
            this._ldapEnvironment = _.find(this.ldapEnvironments, { 'environment': currentEnvironment });
        }, (error) => {
            this.isLoadingLdap = false;
            this._translateService.get('GLOBAL.AN_ERROR_HAS_OCCURRED').subscribe((message: string) => {
                this._toastService.open(
                    message,
                    {
                    type: 'error',
                    duration: 0,
                    verticalPosition: 'top',
                    horizontalPosition: 'right'
                });
            });
        });

        this.loadUserProperties();
    }

    ngAfterViewChecked() {
      this.cdRef.detectChanges();
    }

    ngOnDestroy() {
        this._tabsSubscription.unsubscribe();
    }

    public saveData() {
        if(this.ldapBasicConfiguration.isValid()){
            const environments = { environments: JSON.stringify(this.ldapEnvironments) };
            this.ldapResult[0].content = environments;

            this.ldapService.putLdap(this.ldapResult).subscribe((response) => {
                if (response.save) {
                    this._translateService.get('LDAP.SAVED_SUCCESSFULLY').subscribe((message: string) => {
                        this._toastService.open(
                            message,
                            {
                            type: 'success',
                            duration: 5000,
                            verticalPosition: 'top',
                            horizontalPosition: 'right'
                        });
                    });
                } else if (response.error) {
                  if (this.ERRORS_ATTRIBUTE.indexOf(response.error) > -1) {
                    this._translateService.get('LDAP.ERROR_ATTRIBUTE_' + response.error.toUpperCase())
                    .subscribe((message: string) => {
                      this._toastService.open(
                          message,
                          {
                          type: "error",
                          duration: 0,
                          verticalPosition: "top",
                          horizontalPosition: "right"
                      });
                    });
                  }
                }
            }, (error) => {
                this.isLoadingLdap = false;
                this._translateService.get('GLOBAL.AN_ERROR_HAS_OCCURRED').subscribe((message: string) => {
                    this._toastService.open(
                        message,
                        {
                        type: 'error',
                        duration: 0,
                        verticalPosition: 'top',
                        horizontalPosition: 'right'
                    });
                });
            });
        }
        else {
            this._translateService.get('LDAP.BASIC_INVALID_VALUES_MESSAGE').subscribe((message: string) => {
                this._toastService.open(
                    message,
                    {
                    type: 'error',
                    duration: 0,
                    verticalPosition: 'top',
                    horizontalPosition: 'right'
                });
            });
        }
    }

    public testConnection() {
        if(this.ldapBasicConfiguration.isValid()) {
            this.isTestingLdap = true;
            const environment = JSON.stringify(this._ldapEnvironment);

            this.ldapService.testConnection(environment).subscribe((response) => {
                this.isTestingLdap = false;
                this.testResults = response;
                if (response.status === 'Success') {
                    this.isTestingResultOk = true;
                    this._translateService.get('LDAP.SUCCESSFUL_TEST').subscribe((message: string) => {
                        this._toastService.open(
                            message,
                            {
                                type: 'success',
                                duration: 5000,
                                verticalPosition: 'top',
                                horizontalPosition: 'right'
                            }
                        );
                    });
                } else {
                    const description: string = response.description.startsWith('LDAP error.') ? 'LDAP.ERROR_LDAP_CONFIGURATION' : response.description;
                    this.isTestingResultOk = false;
                    this._translateService.get(description).subscribe((message: string) => {
                        this._toastService.open(
                            message,
                            {
                                type: 'error',
                                duration: 0,
                                verticalPosition: 'top',
                                horizontalPosition: 'right'
                            }
                        );
                    });
                }
            }, (error) => {
                this.isTestingLdap = false;
                this.isTestingResultOk = false;
                this._translateService.get('GLOBAL.AN_ERROR_HAS_OCCURRED').subscribe((message: string) => {
                    this._toastService.open(
                        message,
                        {
                        type: 'error',
                        duration: 0,
                        verticalPosition: 'top',
                        horizontalPosition: 'right'
                    });
                });
            });
        }
        else {
            this._translateService.get('LDAP.BASIC_INVALID_VALUES_MESSAGE').subscribe((message: string) => {
                this._toastService.open(
                    message,
                    {
                    type: 'error',
                    duration: 0,
                    verticalPosition: 'top',
                    horizontalPosition: 'right'
                });
            });
        }
    }

    public viewTestResults() {

        this._modalService.open(LdapTestResultsComponent, {
            closeOnBackdropClick: false,
            closeOnRouterNavigation: true,
            width: '90%',
            height: '90%',
            maxWidth: '90%',
            data: {
                ldapEnvironment: this._ldapEnvironment,
                testResults: this.testResults,
            }
        });
    }

    private loadUserProperties() {
        this.ldapService.getUserProperties().subscribe((response) => {
            this.isLoadingLdap = false;
            this.userProperties = [];
            const _userProperties = response;
            _.forEach(_userProperties, (each) => {
                let valueLower = '';

                if (each.name === 'DelegateEnabled' || each.name === 'CreatedCasesSkipAssigRules') {
                    valueLower = each.name;
                }
                else {
                    valueLower = this.setLowercaseFirstLetter(each.name);
                }

                this.userProperties.push({ value: valueLower });
            });
        }, (error) => {
            this.isLoadingLdap = false;
            this._translateService.get('GLOBAL.AN_ERROR_HAS_OCCURRED').subscribe((message: string) => {
                this._toastService.open(
                    message,
                    {
                    type: 'error',
                    duration: 0,
                    verticalPosition: 'top',
                    horizontalPosition: 'right'
                });
            });
       });
    }

    private setLowercaseFirstLetter(word: string): string {
        return word.charAt(0).toLowerCase() + word.slice(1);
    }
}
